module.exports = __webpack_public_path__ + "Roboto-LightItalic.woff2?e8eaae902c3a4dacb9a5062667e10576";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/LightItalic/Roboto-LightItalic.woff2?v=2.137
// module id = 675
// module chunks = 7